import React from 'react';
import PropTypes from 'prop-types';
import DialogProvider from './DialogProvider';
import useDialog from './useDialog';
import Dialog from './Dialog';

const propTypes = {
  children: PropTypes.node.isRequired,
};

function DialogContextProvider({ children }) {
  const {
    config,
    show,
  } = useDialog();
  return (
    <DialogProvider dispatch={show} value={config}>
      {children}
      <Dialog />
    </DialogProvider>
  );
}

DialogContextProvider.propTypes = propTypes;

export default DialogContextProvider;
